import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Box,
  alpha,
  Alert,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import FormButtonControls from '@/components/forms/formButtonControls/FormButtonControls';

const TokenInfo = ({
  app,
  deployment,
  next,
  back,
  isLastStep,
  isFirstStep,
  handleCancel,
}) => {
  const handleSave = () => {
    next();
  };

  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 2,
        overflow: 'visible',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <CardHeader
        avatar={<InfoIcon color="primary" />}
        title={<Typography variant="h6">PMA Konfiguration</Typography>}
        subheader={`Für ${app?.title || deployment?.title}`}
        sx={{
          bgcolor: (theme) => alpha(theme.palette.primary.light, 0.1),
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      />

      <CardContent sx={{ pt: 3, pb: 2, flex: 1 }}>
        <Alert severity="info" sx={{ mb: 3 }}>
          Nach erfolgreicher Installation erhalten Sie:
        </Alert>

        <Box sx={{ pl: 2 }}>
          <Typography variant="body1" paragraph>
            Einen <strong>Token</strong> für die Authentifizierung
          </Typography>
          <Typography variant="body1" paragraph>
            Eine <strong>Deployment ID</strong> zur Identifikation
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          Diese Werte werden benötigt, um Ihr PMA-Backend mit unserem System zu
          verbinden. Sie erhalten diese Informationen nach Abschluss der
          Installation.
        </Typography>
      </CardContent>

      <Divider />

      <CardActions sx={{ p: 2, justifyContent: 'flex-end' }}>
        <FormButtonControls
          next={next && handleSave}
          back={back}
          cancel={handleCancel}
          isFirstStep={isFirstStep}
          isLastStep={isLastStep}
        />
      </CardActions>
    </Card>
  );
};

export default TokenInfo;
